import React from 'react'

import setContactInterval from '../../actions/setContactInterval'
import intervalFastChoices from '../misc/intervalFastChoices'
import {
  Quiz,
  QuizQuestion,
  QuizAnswers,
  QuizAnswer,
} from '../../styles/quiz'

const IntervalQuiz = ({person}) => (
  <Quiz>
    <QuizQuestion>How often do you want to check in with {person.name}?</QuizQuestion>
    <QuizAnswers>
      {intervalFastChoices.map(choice => (
        <QuizAnswer
          key={choice.name}
          onClick={() => setContactInterval({
            personId: person.id,
            value: choice.data.value,
            unit: choice.data.unit,
          })
        }>
          every {choice.name}
        </QuizAnswer>
      ))}
    </QuizAnswers>
  </Quiz>
)

export default IntervalQuiz



// WEBPACK FOOTER //
// ./src/views/people/IntervalQuiz.js